export enum CustomerStatus {
  LIVE = 1,
  ON_STOP = 2,
  ARCHIVED = 3
}

export enum CompanyType {
  None = 0,
  Organisation = 1,
  Customer = 2,
  Supplier = 3,
  Carrier = 4,
  Branch = 5
}

export enum ContactRoles {
  None = 0,
  Director = 1,
  Manager = 2,
  Processor = 4,
  SalesPerson = 8,
  Surveyor = 16,
  Fitter = 32
}

export enum ContactDepartments {
  MARKETING = 0,
  SALES = 1,
  SALES_ADMIN = 2,
  PRODUCTION = 3,
  DELIVERIES = 4,
  INSTALLATIONS = 5,
  ACCOUNTS = 6,
  CUSTOMER_SERVICE = 7,
  PURCHASING = 8
}

export enum BrandedMode {
  ENABLED = 0,
  FABRICATOR_ENABLED = 1,
  CUSTOMER_ENABLED = 2
}

export enum ImageTypeEnum {
  quotePDFFirstImage = 1,
  quotePDFLastImage = 2,
  emailEquiryImage = 3
}

export enum DocumentType {
  NONE = 0,
  TERMS_AND_CONDITIONS = 1,
  PRIVACY_POLICY = 2,
  RESOURCE_FILE = 3,
  RESOURCE_VIDEO = 4
}

export enum DocumentVideoType {
  NONE = 0,
  YOUTUBE = 1,
  VIMEO = 2
}

export enum LoginStatus {
  SUCCESS = 0,
  FAILURE = 1
}
